import React from "react";
import PresentationIntonationFeedbackDisplay from "../intonation/PresentationIntonationFeedbackDisplay";

const PresentationUserIntonationPanel = ({
  assessment,
  segment,
  visualizationView,
  auth,
  resolvedAssessmentAudioUrl,
  resolvedNarratorAssessmentAudioUrl,
}) => {
  if (!assessment) {
    return (
      <section className="rounded-[28px] border border-white/40 bg-white/80 backdrop-blur-sm shadow-lg shadow-blue-500/5 overflow-hidden">
        <div className="px-4 py-2 border-b border-white/30 bg-gradient-to-r from-white/50 to-white/10">
          <div className="min-w-0">
            <div className="text-[10px] uppercase tracking-[0.18em] text-emerald-500/80 mb-0.5">
              Recorded voice
            </div>
           
          </div>
        </div>

        <div className="p-2">
          <div className="rounded-2xl border border-dashed border-slate-300 bg-white/60 p-5 text-center text-slate-500 min-h-[160px] flex items-center justify-center">
            Record to see your intonation here.
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="rounded-[28px] border border-white/40 bg-white/80 backdrop-blur-sm shadow-lg shadow-blue-500/5 overflow-hidden">
      <div className="px-4  border-b border-white/30 bg-gradient-to-r from-white/50 to-white/10">
        <div className="min-w-0">
          <div className="text-[10px] uppercase tracking-[0.18em] text-emerald-500/80 mb-0.5">
            Recorded voice
          </div>
          
        </div>
      </div>

      <div className="p-2">
        <div className="rounded-2xl border border-white/40 bg-white/60 overflow-hidden">
          <div className="p-2">
            <PresentationIntonationFeedbackDisplay
              assessment={assessment}
              segment={segment}
              view={visualizationView}
              isAdmin={auth?.role === "ADMIN"}
              audioUrl={resolvedAssessmentAudioUrl}
              narratorAudioUrl={resolvedNarratorAssessmentAudioUrl}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PresentationUserIntonationPanel;